import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { messages } from './messages';
import { Button } from '../../button';
import { noop } from '../../../default-props/noop';

import { openAddSalesOrderToBatchFromOrdersGrid } from '../../../../store/orders/grid/orders.grid.header.actions';

import style from './index.module.less';

/**
 * @param {boolean} [props.hasSelectedSpilloverItems]
 * @param {() => void} [props.closePopover]
 */
export const GroupbyActionPopover = ({ hasSelectedSpilloverItems, closePopover = noop }) => {
  const dispatch = useDispatch();
  const addToBatch = useCallback(() => {
    dispatch(openAddSalesOrderToBatchFromOrdersGrid());
    closePopover();
  }, [dispatch, closePopover]);

  return (
    <div className={style['groupby-action-popover-body']}>
      {!hasSelectedSpilloverItems && (
        <Button
          className={style['groupby-action-popover-item']}
          onClick={addToBatch}
          amplitudeTrackingId='/orders#group-by-add-to-batch'
          theme='unstyled'
        >
          <FormattedMessage {...messages.groupOrdersAddToBatch} />
        </Button>
      )}
    </div>
  );
};
